import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { userActions, useAppSelector, useAppDispatch, userSelectors, } from '@pomofocus/shared-client';
import SignupForm from './SignupForm';
import { checkIfElectron } from '../common/DeviceCheck';
import { WebTokenProvider } from '../../utils/webTokenProvider';
import EventTracker from '../../modules/EventTracker';
const SignUpContainer = (props) => {
    const dispatch = useAppDispatch();
    const authenticated = useAppSelector(userSelectors.selectIsAuthenticated);
    const errorMessage = useAppSelector((state) => state.user.signupError);
    const signupWithEmailSucceed = useAppSelector((state) => state.user.signupEmailSucceed);
    const activities = useAppSelector((state) => state.activity.activities);
    const isElectron = checkIfElectron();
    useEffect(() => {
        if (authenticated) {
            props.history.replace('/app');
        }
    }, [authenticated, props.history]);
    const handleClickGoogle = (code, todos) => {
        dispatch(userActions.loginWithGoogle({
            code,
            todos,
            callback: (token) => {
                new WebTokenProvider().saveToken(token);
                dispatch(userActions.fetchUser());
                EventTracker.signUp({ method: 'google' });
                props.history.push('/app');
            },
        }));
    };
    const submit = (email, todos) => {
        dispatch(userActions.displaySignupError({ errorMsg: '' }));
        dispatch(userActions.signupWithEmail({ email, todos }));
        EventTracker.signUp({ method: 'email' });
    };
    const displayErrorMessage = (message) => {
        dispatch(userActions.displaySignupError({ errorMsg: message }));
    };
    const handleClickSwitch = () => {
        dispatch(userActions.displaySignupError({ errorMsg: '' }));
        props.history.push('/login');
    };
    const loginWithAuthCode = (code) => {
        dispatch(userActions.loginWithAuthCode({
            authCode: code,
            callback: (token) => {
                new WebTokenProvider().saveToken(token);
                dispatch(userActions.fetchUser());
                props.history.push('/app');
            },
        }));
    };
    if (authenticated !== false) {
        return null;
    }
    return (React.createElement(SignupForm, { activities: activities, signupWithEmailSucceed: signupWithEmailSucceed, handleClickGoogle: handleClickGoogle, submit: submit, displayErrorMessage: displayErrorMessage, errorMessage: errorMessage, handleClickSwitch: handleClickSwitch, loginWithAuthCode: loginWithAuthCode, isElectron: isElectron }));
};
export default withRouter(SignUpContainer);
